<template>
  <div
    class="container-fluid"
    style="
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      max-width: 100%;
      display: flex;
      align-items: center;
    "
  >
    <!--bg-maintenance-image-->

    <QrCode
      ref="QrCode"
      :name="'QrCode'"
      @onQr="getSerial"
      :serialME="serial_type"
      @onBarcode="getBarcode"
      @onPhoto="getCamRes"
      :photo="photoMode"
      :barCode="barcodeMode"
      :manual="false"
    />
    <modalImg ref="imgzoomC" :name="'modalImg'" :arrImg="modalArr" />

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1 pl-0 pr-0">
      <div class="card border-grey border-lighten-3 box-shadow-3 px-0 pl-0">
        <div class="card-header no-border">
          <div class="row card-title text-xs-center">
            <div class="pt-1 pl-1 pr-1">
              <div class="row col-md-12">
                <!-- <img style="" src="../assets/pictures/icon.png"> -->
                <svg class="d-flex me_logo" />

                <img
                  v-if="userPict"
                  class="profile-pic"
                  style="margin: 0px 5px"
                  :src="userPict"
                  alt="avatar"
                />
                <span
                  v-if="nameUser"
                  style="float: left; margin-left: 3px; max-width: 40%"
                  >{{ nameUser }}</span
                >

                <div style="float: left"></div>

                <!-- <ul class="nav navbar-nav" style="float: right;">
                      <li class="dropdown dropdown-language nav-item">
                        <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle nav-link">
                          <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                        </a>
                        
                        <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                          <a class="dropdown-item" :id="lang" v-for="(lang, index) in listLanguages" :key="index" @click="changeLanguage(lang)">
                            <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                          </a>
                        </div>
                      </li>
                    </ul> -->
              </div>
              <div class="row col-md-12 mt-1">
                <span v-if="WorkCenter" style="float: left">{{
                  WorkCenter
                }}</span>
                <span v-if="WorkCenter && place" style="float: left"
                  >&nbsp-&nbsp</span
                >
                <span v-if="place" style="float: left; max-width: 40%">{{
                  place
                }}</span>
              </div>
            </div>
          </div>

          <h6
            class="card-subtitle line-on-side text-muted text-xs-center font-small-3"
            style="margin-bottom: 5px"
          ></h6>
        </div>

        <div class="card-body">
          <div class="card-block" style="padding: 0 1rem 1rem 1rem">
            <!-- auth -->
            <div class="row col-md-12" v-if="!authorized">
              <div class="col-md-6 offset-md-3">
                <div class="form-group input-group has-icon-left">
                  <input
                    type="text"
                    v-model.trim="$v.card_numb.$model"
                    :class="{ 'border-danger': $v.card_numb.$error }"
                    :placeholder="$t('check.titles.passCard')"
                    class="form-control form-control-lg input-lg"
                    id="card_numb"
                    v-on:keyup.enter="Auth()"
                  />
                  <div class="form-control-position" style="z-index: 4">
                    <i class="icon-head"></i>
                  </div>
                  <div class="input-group-append">
                    <button
                      type="button"
                      @click="
                        barcodeMode = false;
                        photoMode = false;
                        serial_type = false;
                        showModalQR();
                      "
                      class="btn btn-warning btn-round"
                      data-html="true"
                      :title="$t('equipm.hint.barcode')"
                    >
                      <i style="font-size: 1.5rem" class="icon-qrcode"></i>
                    </button>
                  </div>
                </div>
                <span v-if="$v.card_numb.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.card_numb.required">{{
                    $t("errors.required")
                  }}</span>
                </span>
              </div>

              <div
                class="col-md-6 offset-md-3 mb-1"
                style="
                  display: flex;
                  align-content: center;
                  justify-content: center;
                "
              >
                <button
                  type="button"
                  class="btn btn-warning btn-lg btn-block"
                  @click="Auth()"
                >
                  <i style="color: #ffffff" class="icon-unlock2"></i>
                  {{ $t("login.lbl.login") }}
                </button>
              </div>
            </div>
            <!-- auth -->

            <!-- serial -->
            <div class="row" v-if="authorized && stages.serial">
              <div class="col-md-12">
                <span v-if="$v.serial.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.serial.$required">{{
                    $t("errors.required")
                  }}</span>
                </span>
              </div>
              <div class="col-md-8 mb-1" style="margin-top: 5px">
                <div class="input-group">
                  <input
                    type="text"
                    v-model.trim="$v.serial.$model"
                    :class="{ 'border-danger': $v.serial.$error }"
                    :placeholder="$t('equipm.table.serNumber')"
                    class="form-control border-primary form-control-lg input-lg"
                    id="serial"
                    v-on:keyup.enter="$refs.sendSerial.click()"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      ref="sendSerial"
                      class="btn btn-warning btn-round"
                      @click="
                        barcodeMode = false;
                        photoMode = false;
                        serial_type = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.scanQr')"
                    >
                      <i style="font-size: 1.5rem" class="icon-qrcode"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="col-md-4 mb-1 d-flex"
                style="margin-top: 5px; justify-content: center"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-warning"
                  @click="getQuestions()"
                >
                  Отримати список
                </button>
              </div>

              <div
                class="col-md-12 mb-1 d-flex"
                style="margin-top: 5px; justify-content: center"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-warning"
                  @click="openProblemCr()"
                >
                  Створити звернення
                </button>
              </div>

              <div
                class="col-md-12 d-flex"
                style="justify-content: center"
                v-if="!showListAll"
              >
                <!--  -->
                <a class="btn-lg btn-warning" @click="getTroublesAll()">
                  <i class="icon-warning"></i> Список звернень
                </a>
              </div>
              <div
                class="col-md-12 mb-1"
                style="justify-content: center"
                v-if="showListAll"
              >
                <div
                  class="d-flex mb-1"
                  style="
                    border-bottom: 1px solid #1d2b36;
                    justify-content: space-between;
                  "
                >
                  <h4 class="form-section">
                    <i class="icon-warning"></i> {{ $t("titles.problem") }}
                  </h4>

                  <div
                    class="mr-1 hand"
                    @click="
                      showListAll = false;
                      problemsAll = [];
                    "
                  >
                    <i class="icon-cross"></i>
                  </div>
                </div>

                <div class="list-group">
                  <div
                    class="alert alert-warning hand"
                    style="margin-bottom: 0.3rem"
                    v-for="(item, index) in problemsAll"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-md-8">
                        <span
                          class="d-flex"
                          style="
                            font-size: 1.2em;
                            border-bottom: 1px solid #8b8b8b;
                          "
                          >{{ item.status }}</span
                        >
                        <span
                          class="d-flex"
                          style="font-size: 1.2em; font-weight: bold"
                          >{{ item.reason }}</span
                        >
                        <span class="d-flex" style="font-size: 1.2em">{{
                          item.serial
                        }}</span>
                        <span class="d-flex" style="font-size: 1.2em">{{
                          "Опис: " + item.description
                        }}</span>
                        <span class="d-flex" style="font-size: 1.2em">{{
                          "Автор: " + item.author
                        }}</span>
                        <span class="d-flex" style="font-size: 1.2em"
                          >{{ item.date }}&nbsp;<span v-if="item.dateDone">{{
                            "- " + item.dateDone
                          }}</span></span
                        >
                      </div>
                      <div class="col-md-4">
                        <button
                          v-if="item.btnDone && qualityManager"
                          type="button"
                          class="btn btn-lg btn-success"
                          @click="doneProblem(item)"
                          style="float: right"
                        >
                          Виконати
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- serial -->

            <!-- problem -->
            <div class="row mt-1" v-if="authorized && stages.problemCr">
              <div class="col-md-8 offset-md-2 mb-1" style="margin-top: 5px">
                <div class="row mb-1">
                  <div class="col-md-12">
                    <span
                      class="d-flex"
                      style="font-size: 1.25rem"
                      v-if="!selectedReason"
                      >{{ $t("errors.required") }}
                      <span style="color: red">*</span></span
                    >
                    <div class="input-group">
                      <div
                        class="form-control form-control-lg border-primary"
                        :class="{ 'border-danger': $v.selectedReason.$error }"
                        style="background-color: #eceeef"
                        id="typeFltr"
                        @click="problemReason = !problemReason"
                      >
                        <span class="d-flex" style="font-size: 1.25rem">{{
                          titleReason
                        }}</span>
                      </div>

                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-lg btn-primary btn-round"
                          @click="problemReason = !problemReason"
                        >
                          <a class="dropdown-toggle" style="color: white"></a>
                        </button>
                      </div>
                    </div>
                    <div
                      class="dropdown-menu w-100"
                      v-if="problemReason"
                      @mouseleave="problemReason = false"
                    >
                      <!-- <div class="dropdown-item d-flex" v-for="(reason,index) in reasonsProblem" :key="index" @click="selectedReason = reason.guid; problemReason = !problemReason">
                        <span style="max-width: 100%">{{reason.title}}</span>
                      </div> -->
                      <div
                        class="list-group"
                        style="overflow-y: auto; max-height: 50vh"
                      >
                        <span
                          v-for="(reason, index) in reasonsProblem"
                          :key="index"
                          @click="
                            selectedReason = reason.guid;
                            problemReason = !problemReason;
                          "
                          class="list-group-item list-group-item-action"
                          style="font-size: 1.25rem"
                          >{{ reason.title }}</span
                        >
                        <!-- {{active}}-->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <span v-if="$v.selectedReason.$error" style="color: red">{{
                      $t("errors.required")
                    }}</span>
                  </div>
                </div>

                <div class="row mb-1" v-if="!quickAppeal">
                  <div class="col-md-12">
                    <span
                      class="d-flex"
                      style="font-size: 1.25rem"
                      v-if="!selectedDepartm"
                      >{{ $t("errors.required") }}
                      <span style="color: red">*</span></span
                    >
                    <div class="input-group">
                      <!-- <div class="form-control form-control-lg border-primary" :class="{ 'border-danger': $v.selectedDepartm.$error }" style="background-color: #eceeef" id="typeFltr" @click="showdep = !showdep">
                          <span class="d-flex" style="font-size: 1.25rem;">{{titleDep}}</span>
                        </div> -->
                      <input
                        type="text"
                        class="form-control form-control-lg border-primary"
                        :class="{ 'border-danger': $v.selectedDepartm.$error }"
                        style="font-size: 1.25rem"
                        id="department"
                        ref="department"
                        v-model="depStr"
                        :placeholder="titleDep"
                        @input="onInpDep"
                        @click="showdep = true"
                        @mouseenter="
                          showdep = true;
                          $refs.department.focus();
                        "
                        @mouseleave="()=>{
                          if(selectedDepartm){depStr = departmentVal}
                        }"
                        @blur="()=>{
                          if(selectedDepartm){depStr = departmentVal}

                        }"
                      />

                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-lg btn-primary btn-round"
                          @click="showdep = !showdep"
                        >
                          <a class="dropdown-toggle" style="color: white"></a>
                        </button>
                      </div>
                    </div>
                    <div
                      class="dropdown-menu w-100"
                      v-if="showdep"
                      @mouseleave="
                        () => {
                          showdep = false;
                          if (!selectedDepartm) {
                            depStr = null;
                          } else {
                            depStr = departmentVal;
                          }
                        }
                      "
                    >
                      <div
                        class="list-group"
                        style="overflow-y: auto; max-height: 50vh"
                      >
                        <span
                          v-for="(dep, index) in listDepartments"
                          :key="index"
                          @click="()=>{
                            $refs.department.blur();
                            selectedDepartm = dep.guid;
                            departmentVal = dep.title;
                            depStr = dep.title;
                            showdep = !showdep;
                          }
                          "
                          class="list-group-item list-group-item-action"
                          style="font-size: 1.25rem; cursor: pointer"
                          >{{ dep.title }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <span v-if="$v.selectedDepartm.$error" style="color: red">{{
                      $t("errors.required")
                    }}</span>
                  </div>
                </div>

                <div class="input-group mb-1" v-if="!quickAppeal">
                  <input
                    type="text"
                    v-model.trim="$v.serialProbl.$model"
                    @change="checkSerial()"
                    :placeholder="$t('equipm.table.serNumber')"
                    class="form-control form-control-lg input-lg border-primary"
                    :class="{ 'border-danger': $v.serialProbl.$error }"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      ref="sendSerial"
                      class="btn btn-warning btn-round"
                      @click="
                        barcodeMode = false;
                        photoMode = false;
                        serial_type = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.scanQr')"
                    >
                      <i style="font-size: 1.5rem" class="icon-qrcode"></i>
                    </button>
                  </div>
                </div>

                <div class="form-group" v-if="!quickAppeal">
                  <label for="jobs">
                    <span class="d-flex" style="font-size: 1.25rem">{{
                      $t("equipm.table.articule")
                    }}</span>
                  </label>
                  <div class="position-relative">
                    <input
                      type="text"
                      v-model="articule"
                      @change="checkArticule()"
                      class="form-control form-control-lg input-lg border-primary"
                    />
                  </div>
                  <span v-if="checkedArticule">
                    <span class="d-flex">{{ findedArticule }}</span>
                  </span>
                </div>

                <div class="form-group" v-if="!quickAppeal">
                  <label for="brak">
                    <span class="d-flex" style="font-size: 1.25rem"
                      >Брак (шт)</span
                    >
                  </label>
                  <div class="position-relative">
                    <input
                      type="number"
                      class="form-control form-control-lg input-lg border-primary"
                      v-model="defektsCount"
                      id="brak"
                      @keypress="isNumber($event)"
                      pattern="[0-9]*"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="jobs">
                    <span class="d-flex" style="font-size: 1.25rem"
                      >{{ $t("tasks.table.jobs") }}
                      <span style="color: red">*</span></span
                    >
                  </label>
                  <div class="position-relative">
                    <!--<input class="form-control border-primary" type="tel" placeholder="phone number" id="userinput5" pattern="[+]{1}[0-9]{11,14}" v-model="dataEquipment.contacts" disabled>-->
                    <textarea
                      id="jobs"
                      v-model="problemDescript"
                      name="jobs"
                      :class="{ 'border-danger': $v.problemDescript.$error }"
                      rows="4"
                      class="form-control form-control-lg border-primary"
                      style="font-size: 1.25rem"
                    ></textarea>
                  </div>
                  <span v-if="$v.problemDescript.$error" style="color: red">
                    <span class="d-flex" v-if="!$v.problemDescript.$required">{{
                      $t("errors.required")
                    }}</span>
                    <span class="d-flex" v-if="!$v.problemDescript.$minLength"
                      >Minimal length
                      {{ $v.problemDescript.$params.minLength.min }}</span
                    >
                  </span>
                </div>
              </div>
            </div>

            <div class="" v-if="authorized && stages.problemCr">
              <form class="form">
                <h4 class="form-section">
                  <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                </h4>

                <div class="form-group">
                  <input
                    type="file"
                    name="file"
                    id="file"
                    class="inputfile"
                    multiple="multiple"
                    accept="image/x-png,image/jpeg, video/*"
                    @change="onUploadImg"
                    :value="inputFileValue"
                  />
                  <label id="file_loader" for="file">
                    <a class="btn btn-lg btn-primary btn-min-width"
                      ><i class="icon-upload3"></i>
                      {{ $t("tasks.buttons.file") }}</a
                    >
                  </label>
                  <button
                    type="button"
                    class="btn btn-lg btn-warning"
                    @click="
                      photoMode = true;
                      barcodeMode = false;
                      showModalQR();
                    "
                    data-html="true"
                    :title="$t('equipm.hint.camera')"
                  >
                    <i style="color: #ffffff" class="icon-camera8"></i>
                    {{ $t("tasks.buttons.photo") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-danger"
                    @click="images = []"
                    v-if="images.length > 0"
                  >
                    <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                  </button>
                </div>

                <div class="row">
                  <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                    <div
                      class="col-xs-3"
                      style="
                        padding: 0;
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        margin-bottom: 1em;
                      "
                      v-for="(image, index) in images"
                      :key="index"
                    >
                      <div class="card hand mb-0" style="margin-left: 5px">
                        <div class="w-100 h-100">
                          <i
                            class="icon-cross delete-image-icon"
                            @click="images.splice(index, 1)"
                            data-html="true"
                            :title="$t('tasks.hint.delImg')"
                          ></i>
                          <img
                            :src="image.prev"
                            style="max-width: 100%; max-height: 100%"
                            @click="expandDiv(images, index)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- problem -->

            <!-- questions -->
            <div class="row" v-if="authorized && stages.checks">
              <div class="col-md-12" v-if="finishedBy">
                <span style="display: flex; font-size: 1.4rem"
                  >Контроль підтвердив: {{ finishedBy }}</span
                >
              </div>
              <div class="col-md-12" v-if="questions.length > 0">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-file-text2"></i>
                    {{ $t("check.titles.checkList") + " " + serial }}
                  </h4>
                </form>
                <div class="">
                  <div class="table-responsive">
                    <table
                      class="table table-striped table-hover mb-0"
                      cellspacing="0"
                    >
                      <tbody>
                        <tr
                          class="hand alert-warning"
                          v-for="(item, index) in questions"
                          :key="index"
                        >
                          <td @click="changeAnswer(item)">
                            <span
                              v-if="qualityManager"
                              style="
                                display: flex;
                                font-size: 1.4rem;
                                font-weight: bold;
                              "
                              >{{ item.place }}</span
                            >
                            <span style="display: flex; font-size: 1.4rem">{{
                              item.question
                            }}</span>
                          </td>
                          <td style="vertical-align: middle">
                            <fieldset>
                              <input
                                type="checkbox"
                                v-model="item.checked"
                                id="remember-me"
                                class="chk-remember"
                                @click="changeAnswer(item)"
                                :disabled="item.readOnly"
                              />
                            </fieldset>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    class="mt-1 d-flex"
                    v-if="questions.length > 0 && !finishedBy"
                    style="justify-content: flex-end"
                  >
                    <button
                      type="button"
                      class="btn btn-lg btn-success"
                      @click="sendChecks()"
                      style="float: right"
                    >
                      <i class="icon-checkmark2"></i> Відправити
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="col-md-12 mt-1 d-flex"
                style="justify-content: center"
                v-if="countProblems > 0 && problems.length < 1"
              >
                <!--  -->
                <a class="btn btn-lg btn-warning" @click="getListTroubles()">
                  <i class="icon-warning"></i> Звернення ({{ countProblems }})
                </a>
              </div>
              <div
                class="col-md-12 mt-1"
                style="justify-content: center"
                v-if="problems.length > 0"
              >
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-warning"></i> {{ $t("titles.problem") }}
                  </h4>
                </form>
                <div class="list-group">
                  <div
                    class="alert alert-warning hand"
                    style="margin-bottom: 0.3rem"
                    v-for="(item, index) in problems"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-md-8">
                        <span
                          class="d-flex"
                          style="
                            font-size: 1.2em;
                            border-bottom: 1px solid #8b8b8b;
                          "
                          >{{ item.status }}</span
                        >
                        <span
                          class="d-flex"
                          style="font-size: 1.2em; font-weight: bold"
                          >{{ item.reason }}</span
                        >
                        <span class="d-flex" style="font-size: 1.2em">{{
                          "Опис: " + item.description
                        }}</span>
                        <span class="d-flex" style="font-size: 1.2em">{{
                          "Автор: " + item.author
                        }}</span>
                        <span class="d-flex" style="font-size: 1.2em"
                          >{{ item.date }}&nbsp;<span v-if="item.dateDone">{{
                            "- " + item.dateDone
                          }}</span></span
                        >
                      </div>
                      <div class="col-md-4">
                        <button
                          v-if="item.btnDone && qualityManager"
                          type="button"
                          class="btn btn-lg btn-success"
                          @click="doneProblem(item)"
                          style="float: right"
                        >
                          Виконати
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-md-12 d-flex mt-1"
                style="justify-content: center"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-warning"
                  @click="stages.sendPhotos = true"
                >
                  Відправити фото/відео
                </button>
              </div>

              <div
                class="col-md-12 d-flex mt-1"
                style="justify-content: center"
                v-if="qualityManager && !finishedBy"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-success"
                  @click="control()"
                >
                  Контроль
                </button>
              </div>
            </div>
            <!-- questions -->

            <div class="row" v-if="authorized && stages.sendPhotos">
              <div class="col-md-12 mt-1">
                <div class="form-group">
                  <input
                    type="file"
                    name="file"
                    id="file"
                    class="inputfile"
                    multiple="multiple"
                    accept="image/x-png,image/jpeg, video/*"
                    @change="onUploadImg"
                    :value="inputFileValue"
                  />
                  <label id="file_loader" for="file">
                    <a class="btn btn-lg btn-primary btn-min-width"
                      ><i class="icon-upload3"></i>
                      {{ $t("tasks.buttons.file") }}</a
                    >
                  </label>
                  <button
                    type="button"
                    class="btn btn-lg btn-warning"
                    @click="
                      photoMode = true;
                      barcodeMode = false;
                      showModalQR();
                    "
                    data-html="true"
                    :title="$t('equipm.hint.camera')"
                  >
                    <i style="color: #ffffff" class="icon-camera8"></i>
                    {{ $t("tasks.buttons.photo") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-danger"
                    @click="images = []"
                    v-if="images.length > 0"
                  >
                    <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                  </button>
                </div>
              </div>

              <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                <div
                  class="col-xs-3"
                  style="
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    align-content: center;
                    justify-content: center;
                    margin-bottom: 1em;
                  "
                  v-for="(image, index) in images"
                  :key="index"
                >
                  <div class="card hand mb-0" style="margin-left: 5px">
                    <div class="w-100 h-100">
                      <i
                        class="icon-cross delete-image-icon"
                        @click="images.splice(index, 1)"
                        data-html="true"
                        :title="$t('tasks.hint.delImg')"
                      ></i>
                      <img
                        :src="image.prev"
                        style="max-width: 100%; max-height: 100%"
                        @click="expandDiv(images, index)"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-md-12 d-flex mt-1"
                style="justify-content: center"
                v-if="images.length > 0"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-success"
                  @click="sendPhotosQ()"
                >
                  Відправити фото/відео
                </button>
              </div>
            </div>

            <div class="row" style="margin-top: 2rem">
              <div
                class="col-md-12"
                style="display: flex; justify-content: space-between"
              >
                <a class="btn-lg btn-danger" @click="logout()" v-if="exitBtn">
                  <i class="icon-exit"></i> {{ $t("titles.logout") }}
                </a>
                <a
                  class="btn-lg btn-primary"
                  @click="prevFunc()"
                  v-if="backBtn"
                >
                  <i class="icon-undo2"></i> {{ $t("check.btn.back") }}
                </a>

                <button
                  v-if="stages.problemCr"
                  type="button"
                  class="btn btn-lg btn-warning"
                  @click="createProblem()"
                >
                  Створити звернення
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, minValue } from "vuelidate/lib/validators";
import video_logo from "../assets/icons/video.svg";

export default {
  name: "Control",
  components: {},
  data() {
    return {
      inputFileValue: null,

      baseurl: "https://mob1c.modern-expo.com/modern/HS/webapp",
      userGuid: null,
      nameUser: null,
      userPict: null,
      qualityManager: false,

      place: null,
      placeID: null,
      WorkCenter: null,

      card_numb: null,
      serial: null,
      showListAll: false,
      problemsAll: [],

      questions: [],
      countProblems: 0,
      problems: [],
      finishedBy: null,

      problemReason: false,
      selectedReason: null,
      reasonsProblem: [],

      showdep: false,
      selectedDepartm: null,
      departments: [],
      depStr: null,
      departmentVal: null,

      problemDescript: null,
      serialProbl: null,
      checkedSerial: false,
      defektsCount: null,
      ProblemID: null,

      checkedArticule: false,
      articule: null,
      findedArticule: null,

      images: [],
      filesLimit: 15,

      //validation
      errors: [],
      submitStatus: null,
      //validation

      authorized: false,
      stages: {
        serial: false,
        problemCr: false,
        checks: false,
        sendPhotos: false,
      },

      //buttons
      exitBtn: false,
      backBtn: false,
      barcodeMode: false,
      photoMode: false,
      //buttons
      modalArr: [],

      serial_type: true,

      //appeal for Hol
      quickAppeal: false,
    };
  },
  validations: {
    card_numb: { required },
    serial: { required, minLength: minLength(9) },
    selectedReason: { required },
    selectedDepartm: { required },
    serialProbl: { required },
    problemDescript: { required, minLength: minLength(10) },
  },
  methods: {
    Auth() {
      this.$v.$touch();

      if (this.$v.card_numb.$error) {
        this.submitStatus = "ERROR";
        return;
      }

      let dataRequest = {
        number: this.card_numb,
      };

      this.query(
        this.baseurl,
        { method: "loginByCard", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          localStorage.setItem("cardNumber", this.card_numb);

          if (result.UID != undefined) {
            this.userGuid = result.UID;
          }
          if (result.Name != undefined) {
            this.nameUser = result.Name;
          }
          if (result.faceImage != undefined) {
            this.userPict = "data:image/png;base64," + result.faceImage;
          }
          if (result.Place) {
            this.place = result.Place;
            this.placeID = result.PlaceID;
          }
          if (result.WorkCenter) {
            this.WorkCenter = result.WorkCenter;
          }
          if (result.QualityManager && result.QualityManager == true) {
            this.qualityManager = result.QualityManager;
          }

          this.$v.$reset();
          this.authorized = true;

          if (this.quickAppeal) {
            //navigate to appeal
            this.openProblemCr();
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    logout() {
      this.$v.$reset();

      console.log("logout");
      if (!this.quickAppeal) {
        this.cleanUp();
      }
      this.authorized = false;
      this.backBtn = false;
      this.exitBtn = false;

      this.place = null;
      this.placeID = null;
      this.WorkCenter = null;
      this.qualityManager = null;

      this.$v.$reset();
    },
    prevFunc() {
      this.$v.$reset();

      //пробігти по стейджах в своротньому порядку
      if (this.stages.problemCr) {
        this.showListAll = false;
        this.problemsAll = [];

        this.images = [];

        (this.problemReason = false), (this.selectedReason = null);
        this.reasonsProblem = [];

        this.selectedDepartm = null;
        this.departments = [];
        this.depStr = null;
        this.departmentVal = null;

        this.problemDescript = null;
        this.serialProbl = null;
        this.checkedSerial = false;
        this.defektsCount = null;
        this.ProblemID = null;

        this.checkedArticule = false;
        this.articule = null;
        this.findedArticule = null;

        this.stages.serial = true;

        if (this.quickAppeal) {
          this.quickAppeal = false;
        }
      } else if (this.stages.sendPhotos) {
        this.stages.checks = true;
        this.images = [];
      } else if (this.stages.checks) {
        this.showListAll = false;
        this.problemsAll = [];

        this.stages.serial = true;
        this.questions = [];
        this.countProblems = 0;
        this.finishedBy = null;
        this.problems = [];
      }

      // if(this.authorized){//на серіал
      //   //очистка всього
      //   this.logout();
      // }
    },
    cleanUp() {
      this.userGuid = null;
      this.nameUser = null;
      this.userPict = null;
      this.card_numb = null;
      localStorage.removeItem("cardNumber");

      this.serial = null;
      this.problemsAll = [];
      this.showListAll = false;

      this.questions = [];
      this.countProblems = 0;
      this.finishedBy = null;
      this.problems = [];

      this.images = [];

      (this.problemReason = false), (this.selectedReason = null);
      this.reasonsProblem = [];

      this.problemReason = false;
      this.selectedDepartm = null;
      this.departments = [];
      this.depStr = null;
      this.departmentVal = null;

      this.problemDescript = null;
      this.serialProbl = null;
      this.checkedSerial = false;
      this.defektsCount = null;
      this.ProblemID = null;
      this.checkedArticule = false;
      this.articule = null;
      this.findedArticule = null;
    },
    getBarcode(res) {
      this.barcodeMode = false;
      this.card_numb = res;

      this.Auth();
    },
    getCamRes(data) {
      this.photoMode = false;
      if (this.images.length < this.filesLimit) {
        this.images.push({
          name: "image_" + Math.random(100) + ".png",
          data: data.split(",")[1],
          prev: data,
        });
      } else {
        this.$notify({
          group: "info",
          title: "Warning",
          text: "Ліміт файлів " + this.filesLimit,
        });
      }
    },
    getSerial(serial) {
      if (!this.authorized) {
        this.barcodeMode = false;
        this.card_numb = serial;

        this.Auth();
        this.serial_type = true;
      } else if (this.isValid(serial)) {
        if (this.stages.problemCr) {
          this.checkedSerial = true;
          this.serialProbl = serial;
        } else if (this.stages.serial) {
          this.serial = serial;
          this.getQuestions();
        }
      }
    },
    getQuestions() {
      this.errors = [];
      this.$v.$reset();

      this.questions = [];
      this.problems = [];

      this.$v.$touch();
      if (this.$v.serial.$error) {
        this.submitStatus = "ERROR";
        return;
      }

      let dataRequest = {
        serial: this.serial,
        userGuid: this.userGuid,
        placeID: this.placeID,
      };

      this.query(
        this.baseurl,
        { method: "getQuestions", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          if (result.questions) {
            for (let i = 0; i < result.questions.length; i++) {
              this.questions.push({
                order: i,
                guid: result.questions[i].QuestionID,
                question: result.questions[i].Question,
                checked: result.questions[i].Checked,
                place: result.questions[i].Place,
                placeGuid: result.questions[i].PlaceID,
                readOnly: false,
              });

              if (!this.qualityManager && result.questions[i].Checked) {
                this.questions[i].readOnly = true;
              }
            }

            this.questions.sort(function (obj1, obj2) {
              return obj1.order - obj2.order;
            });
          }

          if (result.not_resolved && result.not_resolved != "") {
            this.showNotification("custom-info", result.not_resolved, "", -1);
          }

          if (result.QualityResponsible) {
            this.finishedBy = result.QualityResponsible.name;
          }

          if (result.problems) {
            this.countProblems = result.problems;
          }

          /*if((this.questions.length > 0) || (this.problems.length > 0)){
                this.stages.checks = true;
              }*/
          this.stages.checks = true;

          this.$v.$reset();
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    sendChecks() {
      let not_all_check = false;
      let serial = JSON.parse(JSON.stringify(this.serial));

      let dataRequest = {
        questions: [],
        placeID: this.placeID,
        userGuid: this.userGuid,
        serial: this.serial,
      };

      for (let i = 0; i < this.questions.length; i++) {
        dataRequest.questions.push({
          checked: this.questions[i].checked,
          guid: this.questions[i].guid,
          placeGuid: this.questions[i].placeGuid,
        });

        if (!this.questions[i].checked) {
          not_all_check = true;
        }
      }

      this.query(
        this.baseurl,
        { method: "sendQuestions", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          if (result.not_resolved && result.not_resolved != "") {
            this.showNotification("custom-info", result.not_resolved, "", -1);
          } else {
            this.showNotification(
              "custom-success",
              "Sended",
              "Відправлено",
              -1
            );
          }

          if (not_all_check) {
            this.questions = [];
            this.countProblems = 0;
            this.finishedBy = null;
            this.problems = [];

            this.openProblemCr();
            setTimeout(() => {
              this.serialProbl = serial;
              this.checkedSerial = true;
            }, 500);
          } else {
            this.stages.serial = true;
          }

          this.questions = [];
          this.countProblems = 0;
          this.finishedBy = null;
          this.problems = [];
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    getListTroubles() {
      let dataRequest = {
        userGuid: this.userGuid,
        serial: this.serial,
      };
      this.query(
        this.baseurl,
        { method: "getListTroubles", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          if (result.problems) {
            let newArr = [];
            for (let i = 0; i < result.problems.length; i++) {
              let item = result.problems[i];
              item.dtC = Math.round(new Date(item.Date));
              item.Date = this.dtFormat(item.Date);

              if (!this.dtCheck(item.DateDone)) {
                item.DateDone = null;
              } else {
                item.DateDone = this.dtFormat(item.DateDone);
              }

              this.problems.push({
                dt: item.dtC,
                date: item.Date,
                dateDone: item.DateDone,
                reason: item.reasonProbl,
                reasonGuid: item.reasonProblID,
                description: item.description,
                status: item.Status,
                problGuid: item.ProblemID,
                author: item.AuthorName,
                authorGuid: item.AuthorID,
                btnDone: true,
              });

              if (item.Status == "Виконано") {
                this.problems[i].btnDone = false;
              }
            }

            this.problems.sort((a, b) => b.dt - a.dt);
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    getTroublesAll() {
      let dataRequest = {
        userGuid: this.userGuid,
        serial: "",
      };
      this.problemsAll = [];
      this.query(
        this.baseurl,
        { method: "getListTroubles", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          if (result.problems) {
            for (let i = 0; i < result.problems.length; i++) {
              let item = result.problems[i];
              item.dtC = Math.round(new Date(item.Date));
              item.Date = this.dtFormat(item.Date);

              if (!this.dtCheck(item.DateDone)) {
                item.DateDone = null;
              } else {
                item.DateDone = this.dtFormat(item.DateDone);
              }

              this.problemsAll.push({
                dt: item.dtC,
                date: item.Date,
                dateDone: item.DateDone,
                reason: item.reasonProbl,
                reasonGuid: item.reasonProblID,
                description: item.description,
                status: item.Status,
                serial: item.serial,
                problGuid: item.ProblemID,
                author: item.AuthorName,
                authorGuid: item.AuthorID,
                btnDone: true,
              });

              if (item.Status == "Виконано") {
                this.problemsAll[i].btnDone = false;
              }
            }

            this.problemsAll.sort((a, b) => b.dt - a.dt);

            if (this.problemsAll.length > 0) {
              this.showListAll = true;
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    changeAnswer(item) {
      if (!item.readOnly) {
        item.checked = !item.checked;
      }
    },
    onUploadImg(e) {
      this.inputFileValue = null;
      let elFile = null;
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          elFile = null;
          const element = e.target.files[i];

          elFile = element;
          console.log(elFile);

          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            if (elFile.type.indexOf("image") > -1) {
              this.croppImg(e.target.result).then((result) => {
                let tt = result.split(",");
                if (this.images.length < this.filesLimit) {
                  this.images.push({
                    name: "image_" + Math.floor(Math.random() * 4999) + ".png",
                    data: tt[1],
                    prev: tt[0] + "," + tt[1],
                  });
                } else {
                  this.$notify({
                    group: "info",
                    title: "Warning",
                    text: "Ліміт файлів " + this.filesLimit,
                  });
                }
              });
            }
            if (elFile.type.indexOf("video") > -1) {
              if (elFile.size < 5500000) {
                let filetype = elFile.name.split(".")[1];

                let tt = e.target.result.split(",");
                this.images.push({
                  name:
                    "video_" +
                    Math.floor(Math.random() * 4999) +
                    "." +
                    filetype,
                  data: tt[1],
                  prev: video_logo,
                });
              } else {
                this.showNotification(
                  "custom-error",
                  elFile.name,
                  "Великий розмір файлу",
                  5000
                );
              }
            }
          };
        }
      }
    },
    sendPhotos() {
      let _this = this;
      // REQ-00005353
      let dataRequest = { ProblemID: this.ProblemID, images: [] };

      if (this.images.length > 0) {
        //first run
        dataRequest.images.push({
          data: this.images[0].data,
          name: this.images[0].name,
        });
        getOne();

        function getOne() {
          _this
            .query(
              _this.baseurl,
              { method: "sendFiles", dataRequest: dataRequest },
              { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
            )
            .then((result) => {
              //видалити перший
              dataRequest.images = [];
              _this.images.splice(0, 1);

              if (_this.images.length > 0) {
                dataRequest.images.push({
                  data: _this.images[0].data,
                  name: _this.images[0].name,
                });
                getOne();
              } else {
                _this.prevFunc();
              }
            })
            .catch((result) => {
              _this.showNotification("custom-error", "Error", result);
            });
        }
      } else {
        this.prevFunc();
      }
    },
    sendPhotosQ() {
      let _this = this;
      // REQ-00005353
      let dataRequest = { images: [], serial: this.serial };

      if (this.images.length > 0) {
        //first run
        dataRequest.images.push({
          data: this.images[0].data,
          name: this.images[0].name,
        });
        getOne();

        function getOne() {
          _this
            .query(
              _this.baseurl,
              { method: "addImageSerialNumber", dataRequest: dataRequest },
              { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
            )
            .then((result) => {
              //видалити перший
              dataRequest.images = [];
              _this.images.splice(0, 1);

              if (_this.images.length > 0) {
                dataRequest.images.push({
                  data: _this.images[0].data,
                  name: _this.images[0].name,
                });
                getOne();
              } else {
                _this.prevFunc();
              }
            })
            .catch((result) => {
              _this.showNotification("custom-error", "Error", result);
            });
        }
      } else {
        this.prevFunc();
      }
    },
    createProblem() {
      if (this.ProblemID != null) {
        this.sendPhotos();
        return;
      }

      this.$v.selectedReason.$touch();
      this.$v.problemDescript.$touch();
      //if((this.WorkCenter == null) && (this.departments.length > 0) && !this.quickAppeal ){
      if (this.departments.length > 0 && !this.quickAppeal) {
        this.$v.selectedDepartm.$touch();
      }

      if (this.serialProbl && !this.checkedSerial && !this.quickAppeal) {
        this.showNotification(
          "custom-error",
          "Помилка",
          "Серійний номер не знайдено"
        );
        return;
      }

      if (
        this.$v.selectedReason.$error ||
        this.$v.problemDescript.$error ||
        this.$v.selectedDepartm.$error
      ) {
        return;
      }

      let dataRequest = {
        userGuid: this.userGuid,
        reasonProbl: this.selectedReason,
        departmentID: this.selectedDepartm,
        description: this.problemDescript,
        countDef: this.defektsCount,
        serial: this.serialProbl,
        quickAppeal: this.quickAppeal,
      };

      if (this.articule != null && this.checkedArticule && !this.quickAppeal) {
        dataRequest.article = this.articule;
      }

      this.query(
        this.baseurl,
        { method: "createProblem", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          this.showNotification(
            "custom-success",
            "Створено",
            result.ProblemID,
            -1
          );
          this.$v.selectedReason.$reset();
          this.$v.selectedDepartm.$reset();
          this.$v.problemDescript.$reset();

          if (result.ProblemID) {
            this.ProblemID = result.ProblemID;

            this.sendPhotos();
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    doneProblem(item) {
      let dataRequest = {
        ProblemID: item.problGuid,
        status: "Done",
      };

      this.query(
        this.baseurl,
        { method: "setProblemDone", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          item.btnDone = false;
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    openProblemCr() {
      if (
        this.$route.params.parameter &&
        this.$route.params.parameter == "appeal"
      ) {
        this.quickAppeal = true;
      }

      let dataRequest = { userGuid: this.userGuid };
      this.reasonsProblem = [];
      this.departments = [];

      this.query(
        this.baseurl,
        { method: "getProblemTypes", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          for (let i = 0; i < result.length; i++) {
            this.reasonsProblem.push({
              title: result[i].ProblenType,
              guid: result[i].ProblenTypeID,
            });

            if (this.quickAppeal && result[i].ProblenTypeID == "000000001") {
              this.selectedReason = result[i].ProblenTypeID;
            }
          }

          this.stages.problemCr = true;
          this.$v.$reset();
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });

      this.query(
        this.baseurl,
        { method: "getDepartments", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          for (let i = 0; i < result.length; i++) {
            this.departments.push({
              title: result[i].Department,
              guid: result[i].DepartmentID,
            });
          }

          this.stages.problemCr = true;
          this.$v.$reset();
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    checkSerial() {
      this.checkedSerial = false;
      let dataRequest = { userGuid: this.userGuid, serial: this.serialProbl };
      this.query(
        this.baseurl,
        { method: "checkSerial", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          if (result == true) {
            this.checkedSerial = true;
          }
        })
        .catch((result) => {
          this.checkedSerial = false;
          this.showNotification("custom-error", "Error", result);
        });
    },
    checkArticule() {
      this.checkedArticule = false;
      this.findedArticule = null;
      this.query(
        this.baseurl,
        { method: "checkArticle", dataRequest: { article: this.articule } },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          this.checkedArticule = true;
          this.findedArticule = result;
        })
        .catch((result) => {
          this.checkedArticule = false;
          this.showNotification("custom-error", "Error", result);
        });
    },
    control() {
      let dataRequest = { serial: this.serial, userGuid: this.userGuid };
      this.query(
        this.baseurl,
        { method: "setSerialDone", dataRequest: dataRequest },
        { Authorization: "Basic d2ViYXBwOkpkczIzZHNIRipkZnYyMzQkQCM=" }
      )
        .then((result) => {
          console.log("setSerialDone", result);

          this.stages.serial = true;
          this.questions = [];
          this.countProblems = 0;
          this.finishedBy = null;
          this.problems = [];
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].prev);
        }
        arr = arr2;
      }

      $("#modalImg").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },

    dtCheck(dt) {
      if (dt == null) {
        return false;
      }

      let d = new Date(dt.replace(" ", "T"));
      let year = d.getFullYear();
      if (year < 2000) {
        return false;
      } else {
        return true;
      }
    },

    onInpDep(payload) {
      console.log(payload); //this.depStr = null;
      if (this.depStr && this.depStr.length > 0) {
        this.showdep = true;
      } else if (payload.data == null) {
        this.selectedDepartm = null;
        this.departmentVal = null;
      }
    },
  },
  computed: {
    listLanguages() {
      let arrLang = [];
      for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
        arrLang[
          this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id
        ] = this.$i18n.availableLocales[i];
      }
      return arrLang;
    },
    titleReason: function () {
      if (this.selectedReason == null) {
        return "Оберіть причину";
      } else {
        for (let i = 0; i < this.reasonsProblem.length; i++) {
          if (this.selectedReason == this.reasonsProblem[i].guid) {
            return this.reasonsProblem[i].title;
          }
        }
      }
    },

    titleDep: function () {
      if (this.selectedDepartm == null) {
        return "Оберіть департамент";
      } else {
        for (let i = 0; i < this.departments.length; i++) {
          if (this.selectedDepartm == this.departments[i].guid) {
            return this.departments[i].title;
          }
        }
      }
    },
    listDepartments() {
      let str = "";
      if (this.depStr) {
        //this.depStr
        str = this.depStr.toLowerCase();
      }
      if (str.length > 0) {
        return this.departments.filter((item) => {
          if (item.title.toLowerCase().indexOf(str) > -1) {
            return item;
          }
        });
      } else {
        return this.departments;
      }
    },
  },
  components: {},
  mounted() {
    this.$i18n.locale = "ua";
  },
  watch: {
    exitBtn: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.backBtn = false;
      }
    },
    backBtn: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.exitBtn = false;
      }
    },
    authorized: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        //remove this.stages.
        this.exitBtn = true;
        for (let key in this.stages) {
          this.stages[key] = false;
        }
        this.stages.serial = true;
      }
    },
    "stages.serial": function (newVal, oldVal) {
      if (newVal && !oldVal) {
        //remove this.stages.
        this.stages.problemCr = false;
        this.stages.checks = false;
        this.stages.sendPhotos = false;

        this.exitBtn = true;
      }
    },
    "stages.problemCr": function (newVal, oldVal) {
      if (newVal && !oldVal) {
        //remove this.stages.
        this.backBtn = true;
        this.stages.serial = false;
        this.stages.checks = false;
        this.stages.sendPhotos = false;
      }
    },
    "stages.checks": function (newVal, oldVal) {
      if (newVal && !oldVal) {
        //remove this.stages.
        this.backBtn = true;
        this.stages.serial = false;
        this.stages.problemCr = false;
        this.stages.sendPhotos = false;
      }
    },
    "stages.sendPhotos": function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.backBtn = true;
        this.stages.serial = false;
        this.stages.problemCr = false;
        this.stages.checks = false;
      }
    },
  },
  created() {
    //special parameter for appeal
    if (
      this.$route.params.parameter &&
      this.$route.params.parameter == "appeal"
    ) {
      this.quickAppeal = true;
    }

    if (localStorage.getItem("cardNumber") != null) {
      this.card_numb = localStorage.getItem("cardNumber");
      this.Auth();
    }
    /*
          this.userGuid = result.UID;
          localStorage.setItem('guidUsrChecklist', this.userGuid);
          
          this.nameUser = result.Name;
          localStorage.setItem('nameUsrChecklist', this.nameUser);
          */
  },
};
</script>

<style>
.image-cropper {
  width: 100px;
  height: 100px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}
.me_logo {
  background-image: url(../assets/icons/me_logo.svg);
  background-size: contain;
  background-repeat: no-repeat;
  max-height: 3em;
  width: 3em;
  float: left;
}
.profile-pic {
  height: 3em;
  width: 3em;
  float: left;
  object-fit: contain;
  border-radius: 50%;
}
input[type="checkbox"] {
  /* Double-sized Checkboxes */
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(2);
  padding: 10px;
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
#file_loader,
#file_loader2 {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  cursor: pointer;
}

.border-danger {
  border: 3px solid #da4453 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Control.vue